import { Router, UrlTree } from '@angular/router';

/**
 * UrlTree al sign-in con el destino que se quería abrir en `redirectURL`.
 *
 * Va por `queryParams` y no concatenando `sign-in?redirectURL=${url}`: así el
 * router codifica el valor entero, y un destino con varios parámetros
 * (`/admin/students?search=Juan Perez&status=active`) o con `#` llega intacto
 * al sign-in, que lo lee ya decodificado una sola vez.
 *
 * Desde `/sign-out` no se guarda destino: volver ahí desloguearía al usuario.
 */
export const signInUrlTree = (router: Router, url: string): UrlTree =>
    url === '/sign-out'
        ? router.createUrlTree(['sign-in'])
        : router.createUrlTree(['sign-in'], { queryParams: { redirectURL: url } });
